import styled from "styled-components"

export const Wrap = styled.div`
  display: flex;
  margin-bottom: 25px;
  @media (max-width: 900px) {
   margin-bottom: 50px;
  }
`

export const Placeholder = styled.div`
  width: 270px;
  height: 1px;
  margin-right: 25px;
  flex-shrink: 0;
  @media (max-width: 1000px) {
    width: 220px;
    height: 140px;
    margin-right: 10px;
  }
  @media (max-width: 960px) {
    width: 150px;
    height: 100px;
  }
  @media (max-width: 900px) {
    width: 100px;
    height: 70px;
    margin-right: 10px;
  }
`

export const Image = styled.div<{ src: string }>`
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;
  background-image: url(${({ src }) => src});
  width: 270px;
  height: 170px;
  margin-right: 25px;
  flex-shrink: 0;
  @media (max-width: 1000px) {
    width: 220px;
    height: 140px;
    margin-right: 10px;
  }
  @media (max-width: 960px) {
    width: 150px;
    height: 100px;
  }
  @media (max-width: 900px) {
    width: 100px;
    height: 70px;
    margin-right: 10px;
  }
`

export const SizeTitle = styled.p`
  font-family: Font-Bold;
  font-size: 16px;
  margin-bottom: 10px;
  white-space: nowrap;
`
export const Title = styled.h3`
  font-family: Font-Black;
  text-transform: uppercase;
  font-size: 18px;
  line-height: 24px;
  ul {
    display: inline-flex;
    margin-left: 15px;
  }
`
export const Subtitle = styled.h4`
  font-family: Font-Semibold;
  font-size: 16px;
  line-height: 22px;
  margin-top: 5px;
  padding-right: 20px;
`
export const Table = styled.table`
  width:100%;
`

export const TableWrap = styled.div`
    flex: 1;
`;
export const Td = styled.td<{ align: "left" | "right" }>`
  text-align: ${({ align }) => align};
`
export const Allergies = styled.p`
  font-family: Font-Semibold;
  margin-top: 5px;
  font-size: 13px;
  line-height: 16px;
  text-transform: uppercase;
`
export const ExtraTitle = styled.p`
  font-size: 16px;
  font-family: Font-Bold;
  margin-bottom: 3px;
`
export const ExtraWrap = styled.ul`
  li {
    margin-bottom: 7px;
  }
`

export const Price = styled.h3`
  color: ${({ theme }) => theme.colors.orange};
  font-family: Font-Black;
  font-size: 16px;
`

export const SizeWrap = styled.ul`
  display: flex;
  justify-content: flex-end;
  margin-top: -23px;
  li {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    &:not(:last-child) {
      margin-right: 7px;
    }
  }
`
